import { render, staticRenderFns } from "./Year03.vue?vue&type=template&id=9cbd19ea&scoped=true&"
import script from "./Year03.vue?vue&type=script&lang=js&"
export * from "./Year03.vue?vue&type=script&lang=js&"
import style0 from "./Year03.vue?vue&type=style&index=0&id=9cbd19ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cbd19ea",
  null
  
)

export default component.exports